import type { StaticTextResource } from '../keys'

export const en: StaticTextResource = {
  'schedule.dueToday': 'Due today by {{time}}',
  'schedule.dueTomorrow': 'Due tomorrow by {{time}}',
  'schedule.durationRange':
    '{{start}} - {{end}} (Day {{currentDay}} of {{days}})',
  'editReport.defaultPageName': 'Page {{n}}',
  'editReport.defaultSectionName': 'Section',
  'editReport.defaultRepeatSectionName': 'Repeating section',
}
